
import React from "react";
import { Heading, Text } from "@/lib/typography";

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
}

export function TypographyH1({ children, className }: TypographyProps) {
  return <Heading variant="h1" className={className}>{children}</Heading>;
}

export function TypographyH2({ children, className }: TypographyProps) {
  return <Heading variant="h2" className={className}>{children}</Heading>;
}

export function TypographyH3({ children, className }: TypographyProps) {
  return <Heading variant="h3" className={className}>{children}</Heading>;
}

export function TypographyH4({ children, className }: TypographyProps) {
  return <Heading variant="h4" className={className}>{children}</Heading>;
}

export function TypographyP({ children, className }: TypographyProps) {
  return <Text variant="default" className={className}>{children}</Text>;
}

export function TypographyLead({ children, className }: TypographyProps) {
  return <Text variant="lead" className={className}>{children}</Text>;
}

export function TypographyLarge({ children, className }: TypographyProps) {
  return <Text variant="large" className={className}>{children}</Text>;
}

export function TypographySmall({ children, className }: TypographyProps) {
  return <Text variant="small" className={className}>{children}</Text>;
}

export function TypographyMuted({ children, className }: TypographyProps) {
  return <Text variant="muted" className={className}>{children}</Text>;
}

export function TypographyBrand({ children, className }: TypographyProps) {
  return <Text variant="brand" className={className}>{children}</Text>;
}
